// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1dKIR","legacyBtn":"MutateMid_legacyBtn__362eF"};